<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <!-- <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
      </button> -->
</div>
<div class="modal-body">
    {{ message }}
</div>
<div class="modal-footer confirm-popup" style="display:block !important">
    <button class="btn btn-primary cust-btn" (click)="accept()">{{ btnOkText }}</button>
    <button *ngIf="btnCancelText!=null" class="cancel-button btn" (click)="decline()">{{ btnCancelText }}</button>
</div>
<!-- modal-dialog modal-content --> 